// Generated by ReScript, PLEASE EDIT WITH CARE


function getPayload(payload) {
  return {
          core_pricing_external_id: payload.core_pricing_external_id,
          prioritized_modification_ids: payload.modification_ids
        };
}

export {
  getPayload ,
  
}
/* No side effect */
